import React from 'react';
import { Modal } from 'react-bootstrap';
import ShareDialogMock from './ShareDialogMock';
import currentOwnerName from '../../utils/shareGuideOwner';
import useSharePolling from '../../utils/useSharePolling';
import { GUIDE_COPY as C } from '../../utils/figmaLinkCopy';
import './ShareGuideModal.css';

// "Share your prototype with everyone": one short animation, three steps, and it checks
// again by itself, so there is no button to press afterwards.
//
// The screens are drawn (ShareDialogMock), not screenshots, with a green outline on top.
// Update the drawing if Figma's sharing steps change.
//
//   recheck()   async, returns 'viewable' | 'not_viewable' | 'unknown'
//   onShared()  called once, when it turns viewable
//   onClose()
//   fileName    optional: the user's own file name, shown in the drawn dialog's title
//
// Re-checks every 3 seconds, immediately when this tab regains focus, and stops after 2
// minutes. When it turns viewable it says so and closes itself.
export default function ShareGuideModal({ show, onClose, recheck, onShared, fileName }) {
  const ownerName = currentOwnerName();
  const { done } = useSharePolling({ show, recheck, onShared, onClose });

  return (
    <Modal show={show} onHide={onClose} centered size="lg" className="fgm-modal" aria-labelledby="fgm-title">
      <div className="fgm">
        <div className="fgm-head">
          <h2 id="fgm-title" className="fgm-title">{C.title}</h2>
          <button type="button" className="fgm-close" aria-label="Close" onClick={onClose}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
              <path d="M18 6L6 18M6 6l12 12" />
            </svg>
          </button>
        </div>

        {done ? (
          <div className="fgm-done" role="status">
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#4D9F70" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <circle cx="12" cy="12" r="9" />
              <path d="M8 12.5l3 3 5-6" />
            </svg>
            <div className="fgm-done-title">{C.doneTitle}</div>
            <div className="fgm-done-sub">{C.doneSub}</div>
          </div>
        ) : (
          <>
            <div className="fgm-stage">
              <div className="fgm-scene fgm-a">
                <div className="fgm-shot fgm-zoom-a" style={{ width: 560 }}>
                  <ShareDialogMock scene="a" fileName={fileName} ownerName={ownerName} />
                  <span className="fgm-ring fgm-ring1" aria-hidden="true"><i /></span>
                </div>
              </div>
              <div className="fgm-scene fgm-b">
                <div className="fgm-shot" style={{ width: 349 }}>
                  <ShareDialogMock scene="b" ownerName={ownerName} />
                  <span className="fgm-ring fgm-ring2" aria-hidden="true"><i /></span>
                  <span className="fgm-ring fgm-ring3" aria-hidden="true"><i /></span>
                  <span className="fgm-ring fgm-ring4" aria-hidden="true"><i /></span>
                </div>
              </div>
              <div className="fgm-scene fgm-c">
                <div className="fgm-shot fgm-zoom-c" style={{ width: 560 }}>
                  <ShareDialogMock scene="c" fileName={fileName} ownerName={ownerName} />
                  <span className="fgm-ring fgm-ring5" aria-hidden="true"><i /></span>
                </div>
              </div>
              <div className="fgm-toast" aria-hidden="true">{C.toast}</div>
            </div>

            <div className="fgm-caps" aria-live="polite">
              {C.steps.map(([title, sub], i) => (
                <div key={title} className={`fgm-cap fgm-cap-${'abc'[i]}`}>
                  <div className="fgm-cap-title">{title}</div>
                  <div className="fgm-cap-sub">{sub}</div>
                </div>
              ))}
            </div>
            <div className="fgm-foot">{C.footer}</div>
          </>
        )}
      </div>
    </Modal>
  );
}
